<template>
  <Select
    ref="field"
    v-bind="fieldProps"
    v-on="$listeners"
    @update:value="onValueChange"
    @hasFocus="onPropChange('hasFocus', $event, false)"
  >
    <FieldValidator
      ref="fieldValidator"
      slot="below"
      :validations="validations"
      :value="value"
      :isRequired="isRequired"
      :hasFocus="hasFocus"
      :showMessageOn="showMessageOn"
      @isValid="onPropChange('isValid', $event)"
      @isMessageVisible="onPropChange('isMessageVisible', $event)"
      @failedValidation="onPropChange('failedValidation', $event)"
    >
      <FieldValidation
        :isValid="isValid"
        :isMessageVisible="isMessageVisible"
        :showIndicator="false"
        :message="validationMessage"
        :type="validationType"
      />
    </FieldValidator>
  </Select>
</template>

<script>
import { filter } from '@/helpers/object'
import formFieldInterfaceMixin, {
  VALIDATION_TYPE_VARIANT_MAPPING,
} from '@/components/_shared/Form/form-field-interface-mixin'
import FieldValidator, {
  EVENT_TYPES,
} from '@/components/_shared/Form/Validation/FieldValidator.vue'
import FieldValidation, {
  TYPES as VALIDATION_TYPES,
} from '@/components/_shared/Form/Validation/FieldValidation.vue'
import Select, {
  PLACEHOLDER_VALUE as SELECT_PLACEHOLDER_VALUE,
} from '@/components/_shared/Form/Select/Select.vue'
import propsSelect, { isValidSelectOptions } from '@/components/_shared/Form/Select/props-select'

export const PLACEHOLDER_VALUE = SELECT_PLACEHOLDER_VALUE
export { isValidSelectOptions }

export default {
  name: 'FormSelect',
  components: {
    FieldValidator,
    Select,
    FieldValidation,
  },
  mixins: [formFieldInterfaceMixin],

  // bind attributes to select (not to rool el) using v-bind="$attrs"
  inheritAttrs: false,

  props: { ...propsSelect },

  data() {
    return {
      hasFocus: false,
      isValid: false,
      isMessageVisible: false,
      failedValidation: null,
      EVENT_TYPES,
    }
  },

  computed: {
    fieldProps() {
      return {
        ...this.$attrs,
        ...filter(this._props, Object.keys(propsSelect)),
        variant: this.isMessageVisible
          ? VALIDATION_TYPE_VARIANT_MAPPING[this.validationType]
          : VALIDATION_TYPE_VARIANT_MAPPING['default'],
      }
    },

    validationMessage() {
      return this.failedValidation?.message || ''
    },

    validationType() {
      return this.failedValidation?.type || VALIDATION_TYPES.error
    },
  },

  methods: {
    getIsValid() {
      return this.isValid
    },

    getIsMessageVisible() {
      return this.isMessageVisible
    },

    focus() {
      this.getFieldEl()?.focus()
    },

    validate() {
      this.$refs.fieldValidator.updateOn(EVENT_TYPES.demand)
    },

    setForceMessage({ message = '', type }) {
      if (message) this.$refs.fieldValidator.forceShowMessage({ message, type })
    },

    onPropChange(name, value, emitEvent = true) {
      this[name] = value
      if (emitEvent) this.$emit(name, value)
    },

    onValueChange(value) {
      this.$emit('update:value', value)
    },
  },
}
</script>
